import { render, staticRenderFns } from "./UserOrder.vue?vue&type=template&id=98bcd6ec&scoped=true"
import script from "./UserOrder.vue?vue&type=script&lang=js"
export * from "./UserOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bcd6ec",
  null
  
)

export default component.exports